// Auto-generated by scripts/fetch-holes.mjs
// Source: https://api.golfbert.com/v1/courses/6656/holes
// Generated: 2026-05-04T20:38:14.040Z

export const COURSE_ID = 6656
export const COURSE_NAME = 'Pine Bluff Country Club'
export const COURSE_HOLES_GENERATED_AT = "2026-05-04T20:38:14.040Z"
export const COURSE_HOLES = [
  {
    "number": 1,
    "strokeIndex": 7,
    "par": null,
    "tee": {
      "lat": 34.182160,
      "lng": -92.013430
    },
    "green": {
      "lat": 34.180250,
      "lng": -92.017570
    },
    "range": {
      "x": {
        "min": -92.017570,
        "max": -92.013430
      },
      "y": {
        "min": 34.180250,
        "max": 34.182160
      }
    }
  },
  {
    "number": 2,
    "strokeIndex": 15,
    "par": null,
    "tee": {
      "lat": 34.179812,
      "lng": -92.017462
    },
    "green": {
      "lat": 34.179731,
      "lng": -92.019347
    },
    "range": {
      "x": {
        "min": -92.019347,
        "max": -92.017462
      },
      "y": {
        "min": 34.179731,
        "max": 34.179812
      }
    }
  },
  {
    "number": 3,
    "strokeIndex": 3,
    "par": null,
    "tee": {
      "lat": 34.179727,
      "lng": -92.019847
    },
    "green": {
      "lat": 34.176632,
      "lng": -92.019733
    },
    "range": {
      "x": {
        "min": -92.019847,
        "max": -92.019733
      },
      "y": {
        "min": 34.176632,
        "max": 34.179727
      }
    }
  },
  {
    "number": 4,
    "strokeIndex": 11,
    "par": null,
    "tee": {
      "lat": 34.176784,
      "lng": -92.019204
    },
    "green": {
      "lat": 34.179471,
      "lng": -92.017478
    },
    "range": {
      "x": {
        "min": -92.019204,
        "max": -92.017478
      },
      "y": {
        "min": 34.176784,
        "max": 34.179471
      }
    }
  },
  {
    "number": 5,
    "strokeIndex": 13,
    "par": null,
    "tee": {
      "lat": 34.179752,
      "lng": -92.017216
    },
    "green": {
      "lat": 34.179681,
      "lng": -92.015797
    },
    "range": {
      "x": {
        "min": -92.017216,
        "max": -92.015797
      },
      "y": {
        "min": 34.179681,
        "max": 34.179752
      }
    }
  },
  {
    "number": 6,
    "strokeIndex": 1,
    "par": null,
    "tee": {
      "lat": 34.179014,
      "lng": -92.015879
    },
    "green": {
      "lat": 34.176516,
      "lng": -92.018617
    },
    "range": {
      "x": {
        "min": -92.018617,
        "max": -92.015879
      },
      "y": {
        "min": 34.176516,
        "max": 34.179014
      }
    }
  },
  {
    "number": 7,
    "strokeIndex": 9,
    "par": null,
    "tee": {
      "lat": 34.176691,
      "lng": -92.018941
    },
    "green": {
      "lat": 34.179217,
      "lng": -92.016889
    },
    "range": {
      "x": {
        "min": -92.018941,
        "max": -92.016889
      },
      "y": {
        "min": 34.176691,
        "max": 34.179217
      }
    }
  },
  {
    "number": 8,
    "strokeIndex": 5,
    "par": null,
    "tee": {
      "lat": 34.180053,
      "lng": -92.017106
    },
    "green": {
      "lat": 34.180764,
      "lng": -92.012418
    },
    "range": {
      "x": {
        "min": -92.017106,
        "max": -92.012418
      },
      "y": {
        "min": 34.180053,
        "max": 34.180764
      }
    }
  },
  {
    "number": 9,
    "strokeIndex": 17,
    "par": null,
    "tee": {
      "lat": 34.180773,
      "lng": -92.011882
    },
    "green": {
      "lat": 34.181984,
      "lng": -92.012362
    },
    "range": {
      "x": {
        "min": -92.012362,
        "max": -92.011882
      },
      "y": {
        "min": 34.180773,
        "max": 34.181984
      }
    }
  },
  {
    "number": 10,
    "strokeIndex": 2,
    "par": null,
    "tee": {
      "lat": 34.182391,
      "lng": -92.013996
    },
    "green": {
      "lat": 34.181212,
      "lng": -92.017311
    },
    "range": {
      "x": {
        "min": -92.017311,
        "max": -92.013996
      },
      "y": {
        "min": 34.181212,
        "max": 34.182391
      }
    }
  },
  {
    "number": 11,
    "strokeIndex": 12,
    "par": null,
    "tee": {
      "lat": 34.180410,
      "lng": -92.018196
    },
    "green": {
      "lat": 34.180319,
      "lng": -92.022784
    },
    "range": {
      "x": {
        "min": -92.022784,
        "max": -92.018196
      },
      "y": {
        "min": 34.180319,
        "max": 34.180410
      }
    }
  },
  {
    "number": 12,
    "strokeIndex": 6,
    "par": null,
    "tee": {
      "lat": 34.180890,
      "lng": -92.022536
    },
    "green": {
      "lat": 34.181453,
      "lng": -92.018818
    },
    "range": {
      "x": {
        "min": -92.022536,
        "max": -92.018818
      },
      "y": {
        "min": 34.180890,
        "max": 34.181453
      }
    }
  },
  {
    "number": 13,
    "strokeIndex": 10,
    "par": null,
    "tee": {
      "lat": 34.180958,
      "lng": -92.018567
    },
    "green": {
      "lat": 34.182173,
      "lng": -92.017197
    },
    "range": {
      "x": {
        "min": -92.018567,
        "max": -92.017197
      },
      "y": {
        "min": 34.180958,
        "max": 34.182173
      }
    }
  },
  {
    "number": 14,
    "strokeIndex": 8,
    "par": null,
    "tee": {
      "lat": 34.182473,
      "lng": -92.017466
    },
    "green": {
      "lat": 34.181420,
      "lng": -92.022273
    },
    "range": {
      "x": {
        "min": -92.022273,
        "max": -92.017466
      },
      "y": {
        "min": 34.181420,
        "max": 34.182473
      }
    }
  },
  {
    "number": 15,
    "strokeIndex": 18,
    "par": null,
    "tee": {
      "lat": 34.181342,
      "lng": -92.022779
    },
    "green": {
      "lat": 34.183275,
      "lng": -92.021407
    },
    "range": {
      "x": {
        "min": -92.022779,
        "max": -92.021407
      },
      "y": {
        "min": 34.181342,
        "max": 34.183275
      }
    }
  },
  {
    "number": 16,
    "strokeIndex": 14,
    "par": null,
    "tee": {
      "lat": 34.182817,
      "lng": -92.020497
    },
    "green": {
      "lat": 34.182526,
      "lng": -92.021954
    },
    "range": {
      "x": {
        "min": -92.021954,
        "max": -92.020497
      },
      "y": {
        "min": 34.182526,
        "max": 34.182817
      }
    }
  },
  {
    "number": 17,
    "strokeIndex": 16,
    "par": null,
    "tee": {
      "lat": 34.182013,
      "lng": -92.022087
    },
    "green": {
      "lat": 34.182868,
      "lng": -92.018615
    },
    "range": {
      "x": {
        "min": -92.022087,
        "max": -92.018615
      },
      "y": {
        "min": 34.182013,
        "max": 34.182868
      }
    }
  },
  {
    "number": 18,
    "strokeIndex": 4,
    "par": null,
    "tee": {
      "lat": 34.183024,
      "lng": -92.018007
    },
    "green": {
      "lat": 34.182811,
      "lng": -92.014058
    },
    "range": {
      "x": {
        "min": -92.018007,
        "max": -92.014058
      },
      "y": {
        "min": 34.182811,
        "max": 34.183024
      }
    }
  }
]

// Bounding box matching the exact corners of public/images/pbcc-satellite.png.
// These coords are the source of truth for the linear GPS → pixel projection
// in projectLatLng — every map surface (Command Center, calibration
// watcher, /coursemap, /gpstest watchers) reads from this box. The /map
// page also accepts URL params to override these edges for live calibration
// without redeploying.
export const COURSE_BOUNDS = {
  minLat: 34.1754,
  maxLat: 34.1838,
  minLng: -92.0243,
  maxLng: -92.0113,
}

/** COURSE_HOLES with no datum shift applied. The old Golfbert
 *  GREEN_CORRECTION offset is gone — image corners are the truth now,
 *  so the raw hole anchors line up with the satellite tile directly.
 *  Aliased to COURSE_HOLES so existing consumers (closestHoleByGreen,
 *  any iOS-app-mirror code) keep working without a shift step. */
export const COURSE_HOLES_CORRECTED = COURSE_HOLES

/** Alias of COURSE_BOUNDS. The "_CORRECTED" suffix used to flag that the
 *  bounds came from corrected anchors; now they ARE the image corners
 *  so the corrected-vs-raw distinction is meaningless. Kept exported
 *  because CommandCenter, CalibrationWatcher, and gpstest/Watcher import
 *  it. */
export const COURSE_BOUNDS_CORRECTED = COURSE_BOUNDS

// ── Haversine for hole detection ───────────────────────────────────────
// Equirectangular would be ~5 microseconds faster and accurate enough at
// course scale, but Haversine keeps us honest if Mark wants to compare
// against handheld GPS readings during testing. R = WGS84 mean radius.
const EARTH_R_M = 6371008.8
const toRad = (deg) => (deg * Math.PI) / 180
function haversineMeters(a, b) {
  const dLat = toRad(b.lat - a.lat)
  const dLng = toRad(b.lng - a.lng)
  const lat1 = toRad(a.lat)
  const lat2 = toRad(b.lat)
  const s = Math.sin(dLat / 2) ** 2
        + Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2)
  return 2 * EARTH_R_M * Math.asin(Math.sqrt(s))
}

/**
 * Project a (lat, lng) into pixel-percent coordinates inside a bounding
 * box using simple linear interpolation between the bbox corners.
 *
 *   pctX = (lng - minLng) / (maxLng - minLng)
 *   pctY = (maxLat - lat) / (maxLat - minLat)
 *
 * Returned as 0..100 percentages so CSS `${x}%` / `${y}%` positioning
 * works unchanged across every caller. Replaces the older IDW anchor-
 * blend approach, which pulled the dot toward nearby tee/green anchors
 * and caused visible jumps as the player crossed anchor boundaries.
 *
 * `runtimeCorrection` is accepted for API parity with the previous
 * signature but is no longer needed by the math — the caller already
 * applies the live correction when it computes `bounds` via
 * computeCorrectedBounds(correction). Passing it does nothing.
 *
 * Returns null on invalid input or a degenerate (zero-area) box.
 */
// eslint-disable-next-line no-unused-vars
export function projectLatLng(lat, lng, bounds, runtimeCorrection) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
  if (!bounds) return null
  const { minLat, maxLat, minLng, maxLng } = bounds
  if (maxLat === minLat || maxLng === minLng) return null
  const pctX = (lng - minLng) / (maxLng - minLng)
  const pctY = (maxLat - lat) / (maxLat - minLat)
  return { x: pctX * 100, y: pctY * 100 }
}

// Apply the runtime correction by shifting the image bounds wholesale.
// Positive dLat slides minLat/maxLat north so the same incoming GPS lat
// projects further south on the map; positive dLng slides minLng/maxLng
// east so the same incoming GPS lng projects further west. This pairs
// with the save math in CalibrationWatcher.onSave which derives signs
// assuming a bounds-shift consumer downstream.
export function computeCorrectedBounds(correction) {
  const dLat = Number(correction?.dLat) || 0
  const dLng = Number(correction?.dLng) || 0
  return {
    minLat: COURSE_BOUNDS.minLat + dLat,
    maxLat: COURSE_BOUNDS.maxLat + dLat,
    minLng: COURSE_BOUNDS.minLng + dLng,
    maxLng: COURSE_BOUNDS.maxLng + dLng,
  }
}

/**
 * Closest-corrected-green hole detection.
 *
 *   closestHoleByGreen(34.1872, -92.0179) → { number: 18, meters: 12.4 }
 *
 * Returns null on invalid input. Distance is in meters; the caller can
 * decide whether to gate on a max distance (e.g. >200m = "between
 * holes, don't auto-switch yet").
 */
export function closestHoleByGreen(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
  let best = null
  for (const h of COURSE_HOLES_CORRECTED) {
    const m = haversineMeters({ lat, lng }, h.green)
    if (best === null || m < best.meters) {
      best = { number: h.number, meters: m }
    }
  }
  return best
}
